<template>
  <div style="margin-top: 40px">
    <van-row>
      <van-col style="padding: 10px"
      ><van-tag type="primary" class="title"></van-tag><strong>物流销售总利润分析</strong></van-col>
    </van-row>
    <van-row>
      <van-col span="8" style="background: rgb(53,179,220);color: white;padding: 10px">
        <div>{{ recentData.total | moneyP }}</div>
        <div><span style="font-size: 10px">本月销售总金额</span></div>
      </van-col>
      <van-col span="8" style="background: rgb(72,122,255);color: white;padding: 10px">
        <div>{{ recentData.grossProfit | moneyP }}</div>
        <div><span style="font-size: 10px">毛利</span></div>
      </van-col>
      <van-col span="8" style="background: rgb(72,122,255);color: white;padding: 10px">
        <div>{{ recentData.grossProfitRate }}</div>
        <div><span style="font-size: 10px">毛利率</span></div>
      </van-col>
    </van-row>

    <ve-histogram :data="chartData" :settings="chartSettings" style="margin-top: 20px"></ve-histogram>
  </div>
</template>

<script>
//物流销售利润页
import {spdLogistics} from "@/axios/api";
export default {
  name: "salesProfit",

  created() {
    spdLogistics.getProfit().then(res => {
      if (res.code === 200) {
        this.chartData.rows = res.result
        //当月信息
        this.recentData = res.result[res.result.length-1]
      }
    })
  },

  data() {
    return {
      chartSettings: {
        labelMap: {
        'grossProfit':'毛利'
        },
        yAxisName:['元'],
      },
      chartData: {
        columns: ['date','grossProfit'],
        rows: []
      },
      recentData:''
    }
  },

}
</script>

<style scoped>
.title{
  transform: rotate(90deg);
  font-size: 15px;
  margin-bottom: 2px;
}
</style>



// WEBPACK FOOTER //
// src/spd/logistics/sales-profit.vue